// Návrh názvu a kódu novej partie — jedno pravidlo pre celý Matrix.
// Mirko 17. 9. 2026: „automaticky doplniť názov partie, aby to malo logiku — systémovo, užívateľ to obyčajne urobí zle“.
// Pravidlo zo zaužívaných partií (Mirko 6. 7. 2026 „všetko musí mať systém“):
//   názov = „Remeslo - Priezvisko parťáka“ (Sadra - Dziamko, Cement - Tomáš, Maliari - Korreshi, Potery cement - Hajnos);
//   ak už taký názov existuje, pridá sa začiatočné písmeno krstného mena (Sadra - Mirga F.);
//   kód = rad remesla (PS sadra, PC cement, PM maliari, PH hodinovkári, PP potery, PZ zatepľovači, PV šoféri) + ďalšie číslo.
//   Číslo pridelí server (POST /api/parties s prefixom). Čísla sa neopakujú, lebo sú na palivových kartách.

const RAD = {
  'omietkár-sadra': 'PS', 'sadra': 'PS', 'omietkár-vc': 'PC', 'maliar': 'PM', 'hodinovkár': 'PH',
  'poteráč': 'PP', 'poterac-cement': 'PP', 'poterac-anhydrit': 'PP', 'zateplovac': 'PZ', 'šofer': 'PV',
}
const REMESLO = {
  'omietkár-sadra': 'Sadra', 'sadra': 'Sadra', 'omietkár-vc': 'Cement', 'maliar': 'Maliari', 'hodinovkár': 'Hodinovkári',
  'poteráč': 'Potery', 'poterac-cement': 'Potery cement', 'poterac-anhydrit': 'Potery', 'zateplovac': 'Zatepľovači', 'šofer': 'Šoféri',
}

const slova = (s) => String(s == null ? '' : s).trim().split(/\s+/).filter(Boolean)
// „BARLIK“ → „Barlik“ (celé veľkými písmenami sa v názve partie nepíše)
const pekne = (s) => (s && s.length > 2 && s === s.toUpperCase() && s !== s.toLowerCase()) ? s.charAt(0) + s.slice(1).toLowerCase() : s
const najcastejsi = (pole) => {
  const c = {}
  pole.forEach(x => { if (x) c[x] = (c[x] || 0) + 1 })
  const naj = Object.entries(c).sort((a, b) => b[1] - a[1])[0]
  return naj ? naj[0] : ''
}
const bezPravnejFormy = (firma) => String(firma || '')
  .replace(/,?\s*(spol\.\s*s\s*r\.\s*o\.|s\.\s*r\.\s*o\.|sro|a\.\s*s\.|k\.\s*s\.|v\.\s*o\.\s*s\.|sp\.\s*z\s*o\.\s*o\.|gmbh|ltd\.?)\s*$/i, '')
  .replace(/\s+SL$/i, '').trim()

export function navrhPartie({ zamestnanec, zamestnanci = [], partie = [], skupiny = [] } = {}) {
  const z = zamestnanec || {}
  const skupina = String(z.category || '').trim()

  // meno parťáka: priezvisko z poľa Priezvisko, inak posledné slovo mena; pri firme bez mena skrátený názov firmy
  const menoSlova = slova(z.firstName || z.first_name || '')
  const celeSlova = slova(z.name)
  let priezvisko = String(z.lastName || z.last_name || '').trim()
  let krstne = menoSlova[0] || ''
  if (!priezvisko) {
    const zdroj = menoSlova.length ? menoSlova : celeSlova
    priezvisko = zdroj.length ? zdroj[zdroj.length - 1] : ''
    krstne = zdroj.length > 1 ? zdroj[0] : ''
  }
  if (!priezvisko && z.firma) priezvisko = slova(bezPravnejFormy(z.firma))[0] || ''
  priezvisko = pekne(priezvisko)
  krstne = pekne(krstne)

  // rad (prefix kódu): pravidlo remesla, inak zvyklosť parťákov tej istej skupiny, inak P
  const partaciSkupiny = zamestnanci.filter(e => (e.is_partak == 1 || e.is_partak === true) && e.category === skupina && e.party && String(e.id) !== String(z.id || ''))
  const rad = RAD[skupina] || najcastejsi(partaciSkupiny.map(e => (String(e.party).match(/^(P[A-Z]?)\d+$/) || [])[1])) || 'P'

  // remeslo v názve: pravidlo, inak zvyklosť z názvov partií skupiny, inak názov skupiny
  const idPartiiSkupiny = new Set(partaciSkupiny.map(e => String(e.party)))
  const skupinaNazov = (skupiny.find(g => g.id === skupina) || {}).label || ''
  const remeslo = REMESLO[skupina]
    || najcastejsi(partie.filter(p => idPartiiSkupiny.has(String(p.id)) && String(p.name || '').includes(' - ')).map(p => String(p.name).split(' - ')[0].trim()))
    || skupinaNazov || (skupina ? skupina.charAt(0).toUpperCase() + skupina.slice(1) : '')

  const chyba = !skupina ? 'Najprv vyber Skupinu zamestnanca — podľa nej sa určí remeslo a rad partie.'
    : !priezvisko ? 'Najprv vyplň meno a priezvisko parťáka (pri firme názov firmy).' : ''

  // ďalšie číslo v rade — rovnako ako server (všetky partie vrátane neaktívnych)
  const re = new RegExp('^' + rad + '(\\d+)$')
  const cisla = partie.map(p => (String(p.id).match(re) || [])[1]).filter(Boolean).map(Number)
  const kodNahlad = rad + (cisla.length ? Math.max(...cisla) + 1 : 1)

  if (chyba) return { rad, remeslo, priezvisko, nazov: '', kodNahlad, chyba }

  const aktivne = partie.filter(p => p.active !== 0 && p.active !== '0')
  const obsadene = (n) => aktivne.some(p => String(p.name || '').trim().toLowerCase() === n.toLowerCase())
  const zaklad = remeslo + ' - ' + priezvisko
  let nazov = zaklad
  if (obsadene(nazov) && krstne) nazov = zaklad + ' ' + krstne.charAt(0).toUpperCase() + '.'
  if (obsadene(nazov) && krstne) nazov = zaklad + ' ' + krstne
  for (let i = 2; obsadene(nazov); i++) nazov = zaklad + ' ' + i
  return { rad, remeslo, priezvisko, nazov, kodNahlad, chyba: '' }
}
